export const SOMETHING_WRONG = 'Internal error. Please try again later or contact support.'
export const LOCALE_KEY_NAME = '__locale__'
